import { MainMenuApi } from '../api/api.js'

export default {
  state: {
    codeMenu: '',
    fullPath: '',
    listViewItems: [],
    baseUrl: '',
    restartTicket: ''
  },
  getters: {
    getListViewItems (state) {
      return state.listViewItems
    },
    getFullPath (state) {
      return state.fullPath
    },
    getBaseUrl (state) {
      return state.baseUrl
    },
    getRestartTicket (state) {
      return state.restartTicket
    }
  },
  actions: {
    async loadMenuListItems({ state  }, groupId) {
      let data = await MainMenuApi.getMenuListItems(groupId)
      if (!data && !data.data.iTEnterpriseMenuQuery) {
        return
      }
      state.baseUrl = data.data.iTEnterpriseMenuQuery.menu.baseUrl
      state.listViewItems = data.data.iTEnterpriseMenuQuery.listView.items
    },
    async removeFromFavorite({ state  }, codeMenu) {
      let response = await MainMenuApi.removeFromFavorite(codeMenu)
      let result = response.data.iTEnterpriseMenuMutation.removeFromFavorite
      if (!result.success) {
        console.error(result.errorMessage)
        return
      }
      let item = state.listViewItems.find( x => x.codeMenu === codeMenu) 
      if (item) {
        state.listViewItems.splice(state.listViewItems.indexOf(item), 1)
      }
    },
    async renameFunctionMenu({ state  }, {codeMenu, npp, caption}) {
      let response = await MainMenuApi.renameFunctionMenu(npp, caption)
      let result = response.data.iTEnterpriseMenuMutation.renameFunctionMenu
      if (!result.success) {
        console.error(result.errorMessage)
        return
      }
      let item = state.listViewItems.find( x => x.codeMenu === codeMenu) 
      if (item) {
        item.name = caption
      }
      state.showRenameDialog = false
    },
    async getFullPath({ state  }, codeMenu, startParams) {
      let response = await MainMenuApi.getFullPath(codeMenu, startParams)
      state.fullPath = response.data.iTEnterpriseMenuQuery.fullPath
    },
    async getRestartTicket({ state  }) {
      let response = await MainMenuApi.getRestartTicket()
      state.restartTicket = response.data.iTEnterpriseMenuQuery.getRestartTicket
    },
    async saveListViewItemPosition({ state  }, item) {
      if (item) {
        let data = JSON.parse(localStorage.getItem('appMainMenuCacheMenu'))
        let currentGroup = data.data.iTEnterpriseMenuQuery.menu.currentGroup
        let response = await MainMenuApi.saveListViewItemPosition(currentGroup, JSON.stringify(item))
        let result = response.data.iTEnterpriseMenuMutation.saveListViewItemPosition
        if (result.success) {
          if (state.listViewItems?.length) {
            state.listViewItems[state.listViewItems.findIndex(x => x.codeMenu == item.codeMenu)].position.normal = item.position.normal
          }
        } else {
          console.error(result.errorMessage)
          return
        }
      }
    }
  }
}
